export const ARTIFACT_ID = "picasso-landing-page";
export const WIX_URL = "https://www.wix.com";
export const LOCAL_BASE_URL = "https://local.wix.com:4000";
export const PICASSO_URL = "https://vibe.wix.com";

export const BOTTOM_SHEET_MAX_HEIGHT = 0.9;
export const BOTTOM_SHEET_HALF_HEIGHT = 0.6;
export const BOTTOM_SHEET_MIN_HEIGHT = 0.28;

export const LOCAL_SERVER_BASE_URL =
  process.env.NODE_ENV === "production" ? `${PICASSO_URL}` : LOCAL_BASE_URL;

export const ACCOUNT_SETTINGS_URL =
  "https://manage.wix.com/account/account-settings";
export const SIGN_OUT_URL = `https://manage.wix.com/signout?redirectTo=${PICASSO_URL}`;
export const MY_PROJECTS_URL = "https://manage.wix.com/studio/sites";
export const SIGN_IN_URL = `https://users.wix.com/signin/login`;
export const SIGN_UP_URL = `https://users.wix.com/signin/signup/password`;
export const HELP_CENTER_URL = "https://support.wix.com/en/using-wix-vibe";
export const BUDGET_EXCEEDED_LEARN_MORE_URL =
  "https://support.wix.com/en/article/wix-vibe-about-your-daily-chat-request-limit";
export const FEEDBACK_URL = "https://www.vibe-feedback.com/feedback";
export const MAX_ATTACHMENTS = 5;
export const NOT_PERMITTED_ORIGIN_PARAMS = ["vibe-host", "site_banner"];

export const SUPPORTED_IMAGE_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
] as const;

export type SupportedImageMimeType =
  (typeof SUPPORTED_IMAGE_MIME_TYPES)[number];

export const PANORAMA_TRANSACTION_NAMES = {
  QUERY_SITES: "query-sites",
};

export const SHOW_APP_THEME_TOGGLE_EXPERIMENT =
  "specs.picasso.showAppThemeToggle";

export const FORCE_HEBREW_EXPERIMENT = "specs.picasso.forceHebrew";

export const DESIGNER_NAME_TRANSLATION_KEY_SUFFIX = "_name";

export const RANDOM_DESIGNER_ID = "b4624f9a-cd8c-4131-bf59-6002c71845ff";

export const BUDGET_EXCEEDED_EXPERIMENT =
  "specs.picasso.landingPageBudgetExceeded";

export const INITIAL_GENERATION_NEW_FLOW_EXPERIMENT =
  "specs.picasso.codegenInitialGenerationNewFlow";
